import { Label } from 'semantic-ui-react';
import { ProjectWorkflow, ProjectWorkflowDisplay } from '~/constants';

interface ProjectStatusBadgeProps {
  statusDisplay: string;
  isArchived?: boolean;
}

export default function ProjectStatusBadge({
  statusDisplay,
  isArchived
}: ProjectStatusBadgeProps) {
  const display = ProjectWorkflowDisplay[statusDisplay];
  switch (statusDisplay) {

    // All bidding-related statuses display as "Bidding" (no "Bid Review").
    case ProjectWorkflow.BIDDING:
    case ProjectWorkflow.BID_REVIEW:
      return <Label color="olive">{ProjectWorkflowDisplay[ProjectWorkflow.BIDDING]}</Label>;

    case ProjectWorkflow.IN_DILIGENCE:
      return (
        <Label style={{ background: 'var(--color-light-blue)', color: 'var(--color-pure-black)' }}>
          {display}
        </Label>
      );

    case ProjectWorkflow.EXECUTED:
    case ProjectWorkflow.COMPLETED:
      return (
        <Label style={{ background: 'var(--color-primary-light)' }}>
          {display}
        </Label>
      );

    case ProjectWorkflow.IN_REVIEW:
      return <Label color="yellow">{display}</Label>;

    default:
      return <Label color="grey">{display}</Label>;
  }
}